"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("./constant");

var locationProps = {
  country: _propTypes.string,
  nearestAirport: _propTypes.string,
  city: _propTypes.string
};
var _default = {
  PropTypes: {
    environment: (0, _propTypes.oneOf)(Object.keys(_constant2.ENVIRONMENTS)),
    token: _propTypes.string.isRequired,
    config: (0, _propTypes.shape)({
      consumerId: _propTypes.string,
      locale: _propTypes.string,
      geoid: _propTypes.string,
      currency: _propTypes.string,
      viewport: _propTypes.string,
      userID: _propTypes.string,
      location: (0, _propTypes.shape)(locationProps),
      timestamp: _propTypes.string,
      timeZone: _propTypes.string,
      product: _propTypes.string
    }),
    scriptletVersion: _propTypes.string,
    url: _propTypes.string,
    theme: _propTypes.string
  },
  DefaultProps: {
    config: _constant2.DEFAULT_CONFIG,
    environment: 'staging',
    scriptletVersion: _constant2.MIN_SCRIPTLET_VERSION,
    theme: _constant.DEFAULT_THEME
  }
};
exports.default = _default;